(ns common.schema.entities.counterparty-diligence.notifications
  "Schema-level contract for counterparty-diligence notification emails.

   A notification is a developer-defined map per tenant (see
   `templates/capman/notifications.cljc` etc.) with:

     {:id          <namespaced keyword>   ;; notification identifier
      :label       {:en \"...\"}          ;; UI label
      :description {:en \"...\"}          ;; UI description (optional)
      :variants    [<variant> ...]}       ;; per-form-template variants

   Each variant is keyed by the form-template-id it applies to, and carries
   its own subject/body/placeholders/sample-context:

     {:template-id    <form template id>
      :label          {:en \"Project diligence\"}
      :subject        \"...\"
      :body           \"...\"
      :placeholders   [{:key k :label {...}}]
      :sample-context {<placeholder-key> ...}}

   Recipients are tenant-configurable via the UI and shared across all
   variants of a notification; everything else is developer-controlled in
   per-tenant code, mirroring the form-template structure."
  (:require
   [clojure.string :as string]
   [common.util :as cu]))

(defn render
  "Substitute {{key}} placeholders in `template-str` using `context`.
   Missing or nil values render as an empty string."
  [template-str context]
  (when (string? template-str)
    (reduce (fn [s [k v]]
              (string/replace s
                              (re-pattern (str "\\{\\{" (name k) "\\}\\}"))
                              (str (or v ""))))
            template-str
            context)))

(defn variant-for-template
  "Return the notification variant matching `template-id`, or nil."
  [notification template-id]
  (->> notification
       :variants
       (cu/find-first-by :template-id template-id)))
